import { NgModule } from '@angular/core';
import { DownloadComponent } from './download.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { DatePipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [DownloadComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslateModule,
    ComponentsModule,
    MatProgressSpinnerModule,
    RouterModule.forChild([
      {
        path: '',
        component: DownloadComponent,
      },
    ]),
  ],
  providers: [DatePipe],
})
export class DownloadScreenModule {}
